import _ from "lodash";
import { fetchApi, toObject } from "../../utils";

const getCategoriesApi = () => {
  return fetchApi("categories")
    .then(res => _.get(res, "data"))
    .then(toObject);
};

export { getCategoriesApi };



// WEBPACK FOOTER //
// ./src/services/product/categories.js